// import React from "react";
// import ReactDOM from "react-dom";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";
// import { Provider } from "react-redux";
// import store from "./redux/store";
// import { CssBaseline } from "@mui/material";
// import { ThemeProvider } from "@mui/material/styles";
// import "./Translation/i18n";
// import mwtheme from "./mwtheme";
// import { BrowserRouter } from "react-router-dom";

// ReactDOM.render(
//   <Provider store={store}>
//     <BrowserRouter>
//       {/* <StylesProvider injectFirst> */}
//       <ThemeProvider theme={mwtheme}>
//         <CssBaseline enableColorScheme />
//         {/* <Provider store={store}> */}
//           <App />
//           </ThemeProvider>
//         {/* </Provider> */}
//         {/* </Provider>, */}
//         {/* document.getElementById('root') as HTMLElement */}
//       {/* </StylesProvider> */}
//     </BrowserRouter>
//   </Provider>,
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./redux/store";
// import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import mwtheme from "./mwtheme";
// import './i18n';

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* <BrowserRouter> */}
      <ThemeProvider theme={mwtheme}>
        <App />
      </ThemeProvider>
      {/* </BrowserRouter> */}
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
